import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "captchaRecordList",
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticClass: "content"
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("a-table", {
    staticClass: "components-table-demo-nested",
    attrs: {
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.dataList,
      pagination: _vm.pagination
    },
    on: {
      change: _vm.changePage,
      showSizeChange: _vm.showSizeChange
    },
    scopedSlots: _vm._u([{
      key: "custom",
      fn: function fn(tetx, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(record.name) + " "), _c("br"), _vm._v(" " + _vm._s(record.identity) + " ")]);
      }
    }, {
      key: "custom2",
      fn: function fn(tetx, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(record.customerEmail) + " "), _c("br"), _vm._v(" " + _vm._s(record.phoneType + " " + record.phone) + " ")]);
      }
    }, {
      key: "custom3",
      fn: function fn(tetx, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(record.country) + " "), _c("br"), _vm._v(" " + _vm._s(record.addressPost) + " ")]);
      }
    }, {
      key: "consultationType",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(record.consultationType) + " ")]);
      }
    }, {
      key: "consultationContent",
      fn: function fn(text, record) {
        return [_c("a-tooltip", {
          attrs: {
            overlayClassName: "atooltip",
            placement: "left"
          }
        }, [_c("template", {
          slot: "title"
        }, [_c("div", {
          domProps: {
            innerHTML: _vm._s(text)
          }
        })]), _vm._v(" " + _vm._s(text) + " ")], 2)];
      }
    }, {
      key: "createTime",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(_vm._s(_vm.formatTimestamp(text)))]);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "customTitle"
    },
    slot: "customTitle"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("contactUs.name")))]), _vm._v(" "), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("contactUs.identity")))])]), _c("span", {
    attrs: {
      slot: "customTitle2"
    },
    slot: "customTitle2"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("contactUs.customerEmail")))]), _vm._v(" "), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("contactUs.phone")))])]), _c("span", {
    attrs: {
      slot: "customTitle3"
    },
    slot: "customTitle3"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("contactUs.country")))]), _vm._v(" "), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("contactUs.addressPost")))])])])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };